import { t as Swiper } from "./swiper.esm-Dvfjl6Fb.js";
import { t as handleProductSections } from "./product-utils-CBxrtRYw.js";
//#region src/scripts/extenders/swatch-variant.js
var SwatchVariantSelect = class extends HTMLElement {
	constructor() {
		super();
		const swatchHolder = this.querySelector(".product-swatches");
		const swatchRadios = this.querySelectorAll(".swatch__radio");
		const mediaSlider = document.querySelector(".media-slider");
		const thumbs = document.querySelector(".thumbs");
		new Swiper(swatchHolder, {
			slidesPerView: "auto",
			freeMode: true,
			spaceBetween: 16
		});
		const handleDefaultVariant = (variantData, productHandle) => {
			const url = new URL(window.location.href);
			url.searchParams.delete("variant");
			const rootUrl = this.dataset.rootUrl === "/" ? "" : this.dataset.rootUrl || "";
			url.href = `${url.origin}${rootUrl}/products/${productHandle}`;
			history.replaceState({}, "", url.href);
			handleProductSections(url.href);
		};
		const handleVariantSelect = (swatchNumber, productHandle, templateId) => {
			const variantData = JSON.parse(document.querySelector(".variants-data").innerHTML);
			if (variantData[0].variants?.length === void 0) handleDefaultVariant(variantData, productHandle);
			const selectedModule = document.querySelector(".module__radio:checked")?.dataset.moduleLetter ? document.querySelector(".module__radio:checked")?.dataset.moduleLetter : "";
			const correctProduct = variantData[0].module ? variantData.filter((variant) => variant.module.includes(selectedModule)) : variantData;
			const selectedSide = document.querySelector(".variant-options__radio:checked")?.value;
			let variant = correctProduct[0].variants === void 0 ? correctProduct.filter((variant) => variant.title.includes(swatchNumber) && variant.title.includes(selectedSide !== void 0 ? selectedSide : "")) : correctProduct[0].variants.filter((variant) => variant.title.includes(swatchNumber) && variant.title.includes(selectedSide !== void 0 ? selectedSide : ""));
			if (variant.length === 0) variant = correctProduct[0];
			const url = new URL(window.location.href);
			url.searchParams.set("view", templateId);
			const variantId = variant[0]?.id !== void 0 ? variant[0].id : variant.id;
			url.searchParams.set("variant", variantId);
			history.replaceState({}, `variant-${variantId}`, url.href);
			window.location.href = url.href;
		};
		const updateFlowbox = (id) => {
			window.flowbox("update", {
				key: "s-powJUJS0Ok-5Xkdkj1Ww",
				tags: [id],
				tagsOperator: "any"
			});
		};
		swatchRadios.forEach((radio) => {
			radio.addEventListener("change", (e) => {
				mediaSlider.classList.add("loading");
				thumbs.classList.add("loading");
				sessionStorage.setItem("selectedSwatch", e.target.value);
				handleVariantSelect(e.target.value, e.target.id, e.target.getAttribute("data-template-id"));
				updateFlowbox(e.target.value);
			});
		});
	}
};
if (customElements.get("swatch-variant") === void 0) customElements.define("swatch-variant", SwatchVariantSelect);
//#endregion
